/* Antistatik · refonte v3.3, tâche K3 (23/10/2026) : liste de favoris sans compte client ni application.
   Chargé (différé) par snippets/ask-favori-entete.liquid, dans l'en-tête de toutes les pages.
   - Les handles des produits sont gardés dans le navigateur (localStorage « ask-favoris », du plus récent au plus ancien,
     60 au plus). Lecture et écriture dans des try/catch : si le stockage est bloqué (navigation privée, réglages), la liste
     vit en mémoire le temps de la page et le site marche normalement.
   - Un seul écouteur de clic sur le document pour tous les cœurs (snippets/ask-favori-bouton.liquid), y compris ceux des
     cartes ajoutées après coup (« Vous aimerez aussi », filtres) : un observateur les met à jour quand elles arrivent.
   - Met à jour sans recharger : aria-pressed et libellé des cœurs, nombre de l'en-tête, autres onglets (événement storage).
   - Aucun appel réseau. La page /pages/favoris (assets/ask-favori-page.js) se sert de window.askFavoris et de
     l'événement « ask:favoris ». */
(function () {
  'use strict';
  if (window.askFavoris) return;

  var CLE = 'ask-favoris';
  var MAX = 60;
  var memoire = null; // copie de secours quand le stockage du navigateur est bloqué
  var valide = function (h) { return typeof h === 'string' && /^[a-z0-9][a-z0-9_-]{0,254}$/i.test(h); };

  function lire() {
    if (memoire) return memoire.slice();
    try {
      var v = JSON.parse(window.localStorage.getItem(CLE) || '[]');
      if (Array.isArray(v)) return v.filter(valide).filter(function (h, i, t) { return t.indexOf(h) === i; }).slice(0, MAX);
    } catch (e) { /* stockage illisible : liste vide */ }
    return [];
  }

  function ecrire(liste, detail) {
    liste = liste.slice(0, MAX);
    try {
      window.localStorage.setItem(CLE, JSON.stringify(liste));
      memoire = null;
    } catch (e) {
      memoire = liste.slice(); // stockage bloqué ou plein : la liste reste en mémoire pour cette page
    }
    maj();
    try {
      var d = detail || {};
      d.liste = liste.slice();
      document.dispatchEvent(new CustomEvent('ask:favoris', { detail: d }));
    } catch (e) { /* navigateur très ancien */ }
  }

  function ajouter(h, position) {
    if (!valide(h)) return;
    var l = lire().filter(function (x) { return x !== h; });
    var i = typeof position === 'number' && position >= 0 && position <= l.length ? position : 0;
    l.splice(i, 0, h);
    ecrire(l, { handle: h, ajoute: true });
  }

  function retirer(h) {
    var l = lire();
    var i = l.indexOf(h);
    if (i < 0) return -1;
    l.splice(i, 1);
    ecrire(l, { handle: h, ajoute: false, position: i });
    return i;
  }

  function basculer(h) {
    if (lire().indexOf(h) > -1) { retirer(h); return false; }
    ajouter(h, 0);
    return true;
  }

  function majBoutons(l, racine) {
    (racine || document).querySelectorAll('[data-ask-favori]').forEach(function (b) {
      var on = l.indexOf(b.getAttribute('data-ask-favori')) > -1;
      if (b.getAttribute('aria-pressed') !== String(on)) b.setAttribute('aria-pressed', String(on));
      var lib = b.querySelector('[data-ask-favori-libelle]');
      var txt = on ? 'Retirer des favoris' : 'Ajouter aux favoris';
      if (lib && lib.textContent !== txt) lib.textContent = txt;
    });
  }

  function majEntete(l) {
    var n = l.length;
    document.querySelectorAll('[data-ask-favori-entete]').forEach(function (a) {
      a.classList.toggle('ask-favori-entete--vide', n === 0);
      var nb = a.querySelector('.ask-favori-entete__nb');
      if (nb) nb.textContent = n ? String(n) : '';
      var lu = a.querySelector('[data-ask-favori-lu]');
      if (lu) lu.textContent = n ? 'Mes favoris (' + n + ' produit' + (n > 1 ? 's' : '') + ')' : 'Mes favoris';
    });
  }

  function maj() {
    var l = lire();
    majBoutons(l);
    majEntete(l);
    // Les règles temporaires de l'en-tête (cœurs pleins avant ce script) ne servent plus : l'état vient d'aria-pressed.
    document.documentElement.classList.remove('ask-fav-init');
  }

  function animer(el, classe) {
    if (!el || (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches)) return;
    el.classList.remove(classe);
    void el.offsetWidth; // relance l'animation
    el.classList.add(classe);
    setTimeout(function () { el.classList.remove(classe); }, 450);
  }

  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-ask-favori]') : null;
    if (!b) return;
    e.preventDefault();
    var ajoute = basculer(b.getAttribute('data-ask-favori'));
    if (ajoute) {
      animer(b, 'is-pop');
      document.querySelectorAll('[data-ask-favori-entete]').forEach(function (a) { animer(a, 'is-pop'); });
    }
  });

  // Autre onglet : même liste partout.
  window.addEventListener('storage', function (e) { if (e.key === CLE || e.key === null) maj(); });

  // Cœurs ajoutés après coup (recommandations, filtres, recherche) : mis à jour à leur arrivée, une fois par image.
  var attente = false;
  if ('MutationObserver' in window) {
    new MutationObserver(function (mutations) {
      if (attente) return;
      for (var i = 0; i < mutations.length; i++) {
        var ajoutes = mutations[i].addedNodes;
        for (var j = 0; j < ajoutes.length; j++) {
          var n = ajoutes[j];
          if (n.nodeType === 1 && (n.hasAttribute('data-ask-favori') || n.querySelector('[data-ask-favori]'))) {
            attente = true;
            (window.requestAnimationFrame || setTimeout)(function () { attente = false; majBoutons(lire()); });
            return;
          }
        }
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
  }

  window.askFavoris = { liste: lire, ajouter: ajouter, retirer: retirer, basculer: basculer, maj: maj, max: MAX };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', maj);
  else maj();
})();
